/**
 * Base Auth Adapter
 * 
 * Abstract base class that defines the interface for all authentication adapters.
 * Each adapter (Azure AD, Parent Portal, etc.) must implement these methods.
 */

class BaseAuthAdapter {
  /**
   * Validate if the user is authenticated
   * @param {boolean} forceRefresh - Force refresh the validation
   * @returns {Promise<{isValidUser: boolean, userInfo?: object, token?: string}>}
   */
  async validateUser(forceRefresh = false) {
    throw new Error('validateUser must be implemented by adapter');
  }

  /**
   * Get the current authentication token
   * @returns {string | null}
   */
  getToken() {
    throw new Error('getToken must be implemented by adapter');
  }

  /**
   * Initiate login flow
   * @param {object} options - Login options
   * @returns {Promise<void>}
   */
  async login(options = {}) {
    throw new Error('login must be implemented by adapter');
  }

  /**
   * Handle logout
   * @returns {Promise<void>}
   */
  async logout() {
    throw new Error('logout must be implemented by adapter');
  }

  /**
   * Get user information
   * @returns {Promise<object | null>}
   */
  async getUserInfo() {
    throw new Error('getUserInfo must be implemented by adapter');
  }

  /**
   * Check if user is authenticated (synchronous)
   * @returns {boolean}
   */
  isAuthenticated() {
    throw new Error('isAuthenticated must be implemented by adapter');
  }

  /**
   * Refresh the authentication token
   * @returns {Promise<string | null>}
   */
  async refreshToken() {
    throw new Error('refreshToken must be implemented by adapter');
  }
}

export default BaseAuthAdapter;

